import e from "../locale/en_US.js";
import { CONFIG_PROVIDER_DIRECTION_INJECT_KEY as t, CONFIG_PROVIDER_LOCALE_INJECTION_KEY as n, CONFIG_PROVIDER_TELEPORT_RENDER_DISABLED_INJECT_KEY as r } from "./injectionKeys.js";
import { computed as i, inject as a } from "vue";
//#region src/components/ui/config-provider/useConfigProvider.ts
function o() {
	let o = a(n, i(() => e));
	return {
		locale: o,
		dir: a(t, i(() => o.value.dir)),
		teleportRenderDisabled: a(r, i(() => !1))
	};
}
//#endregion
export { o as useConfigProvider };

//# sourceMappingURL=useConfigProvider.js.map